export const content = {
  christianSzegedy: {
    poster: {
      episode: 'Episode 1',
      name: 'Christian Szegedy',
      description:
        'Christian Szegedy is a researcher at Google Brain. He discovered adversarial examples, invented BatchNorm.',
      position: 'Staff Research Scientist at Google AI',
      imageSrc: 'szegedy',
      href: '/interviews/christian-szegedy',
      background:
        'linear-gradient(135deg, rgba(255, 255, 255, 0.7) 0.5%, rgba(255, 255, 255, 0) 59.49%), linear-gradient(90deg, #943CFF 0%, #DD45D3 50%, #FD9D52 100%)'
    }
  },
  jeremyHoward: {
    poster: {
      episode: 'Episode 2',
      name: 'Jeremy Howard',
      description:
        'Jeremy Howard is an entrepreneur, business strategist, developer, and educator. He is a founding researcher at fast.ai.',
      position: 'Deep learning researcher & educator',
      imageSrc: 'howard',
      href: '/interviews/jeremy-howard',
      background:
        'linear-gradient(237.9deg, rgba(255, 255, 255, 0.7) 5.51%, rgba(255, 255, 255, 0) 73.97%), linear-gradient(292.1deg, #943CFF 0%, #DD45D3 52.95%, #FD9D52 100%)'
    }
  }
};
